import React, { useEffect, useState } from "react";
import { Wallet as WIcon, Clock, TrendingUp, ArrowDownToLine, Gift } from "lucide-react";
import api, { inr } from "@/lib/api";
import { StatCard } from "@/components/StatCard";

const STATUS_STYLE = {
  approved: "bg-teal-50 text-teal-700", pending: "bg-amber-50 text-amber-700",
  reversed: "bg-rose-50 text-rose-700", paid: "bg-indigo-50 text-indigo-700",
  completed: "bg-slate-100 text-slate-600", flagged_review: "bg-amber-50 text-amber-700",
};
const TYPE_LABEL = {
  referral_signup_bonus: "Referral Signup Bonus",
  referral_reward: "Referral Reward", upstream_referral_reward: "Upstream Reward",
  withdrawal: "Withdrawal", milestone_reward: "Milestone Reward",
  signup_bonus: "Signup Bonus", signup_bonus_redeem: "Bonus Redeemed",
  reversal: "Fund Reversal",
};

export default function WalletPage() {
  const [s, setS] = useState(null);
  const [ledger, setLedger] = useState([]);
  useEffect(() => {
    api.get("/wallet/summary").then((r) => setS(r.data)).catch(() => {});
    api.get("/wallet/ledger").then((r) => setLedger(r.data)).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0B223D]">Earnings Wallet</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-5">
        <StatCard label="Available" value={inr(s?.available)} icon={WIcon} accent="emerald" testid="wallet-available" />
        <StatCard label="Pending" value={inr(s?.pending)} icon={Clock} accent="amber" testid="wallet-pending" />
        <StatCard label="Lifetime Earned" value={inr(s?.lifetime)} icon={TrendingUp} accent="navy" />
        <StatCard label="Withdrawn" value={inr(s?.withdrawn)} icon={ArrowDownToLine} accent="indigo" />
        <StatCard label="Signup Bonus Points" value={s?.bonus ?? 0} icon={Gift} accent="rose" testid="wallet-bonus" sub="5% added on every withdrawal" />
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <div className="p-5 border-b border-slate-100"><h3 className="font-display font-bold text-[#0B223D]">Transaction ledger</h3></div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="wallet-ledger-table">
            <thead className="bg-slate-50 text-slate-400 text-xs uppercase">
              <tr><th className="text-left p-3.5">Transaction</th><th className="text-left p-3.5">Type</th><th className="text-left p-3.5">Date</th><th className="text-left p-3.5">Status</th><th className="text-right p-3.5">Amount</th></tr>
            </thead>
            <tbody>
              {ledger.length === 0 ? (
                <tr><td colSpan={5} className="p-8 text-center text-slate-400">No transactions yet. Start referring to earn!</td></tr>
              ) : ledger.map((e) => (
                <tr key={e.id} className="border-t border-slate-100">
                  <td className="p-3.5 font-mono-num text-xs text-slate-500">{e.txn_id}</td>
                  <td className="p-3.5 font-medium text-[#0B223D]">{TYPE_LABEL[e.type] || e.type}</td>
                  <td className="p-3.5 text-slate-400">{new Date(e.created_at).toLocaleDateString("en-IN")}</td>
                  <td className="p-3.5"><span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${STATUS_STYLE[e.status] || "bg-slate-100 text-slate-600"}`}>{e.status}</span></td>
                  <td className={`p-3.5 text-right font-mono-num font-bold ${e.amount < 0 ? "text-rose-600" : "text-teal-600"}`}>{e.amount < 0 ? "-" : "+"}{inr(Math.abs(e.amount))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
